import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import CommonLoader from '../../../shared/loaders/CommonLoader';
import SplitPartsTable from './SplitPartsTable';

const SplitParts = ({ loading, selectedParts, setSelectedParts }) => {
  const visitParts = useSelector((state) => state.visitParts.visitParts);

  const handleSelect = (part) => {
    setSelectedParts((prevSelectedParts) =>
      prevSelectedParts.includes(part.id)
        ? prevSelectedParts.filter((partId) => partId !== part.id)
        : [...prevSelectedParts, part.id],
    );
  };

  const handleSelectAll = () => {
    if (selectedParts.length === visitParts.length) {
      setSelectedParts([]);
    } else {
      setSelectedParts(visitParts.map((part) => part.id));
    }
  };

  return visitParts.length && !loading ? (
    <div className="flex flex-col gap-3 md:gap-4">
      <Suspense fallback={<CommonLoader />}>
        <div className="w-fit flex justify-start font-header2 text-xs md:text-sm text-bg5">
          Виберіть деталі для перенесення
        </div>
        <SplitPartsTable
          visitParts={visitParts}
          selectedParts={selectedParts}
          onVisitPartSelect={handleSelect}
          onSelectAll={handleSelectAll}
          allSelected={selectedParts.length === visitParts.length}
        />
      </Suspense>
    </div>
  ) : (
    <></>
  );
};

export default SplitParts;
